import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=911242a4&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&id=911242a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911242a4",
  null
  
)

export default component.exports